import { Product } from "../shared/sdk/types"
import { formatPrice } from "../shared/utils/format"
import i18n from "../i18n/config"

const smallprint = (language: string, product?: Product) => {
    if (!product) return

    return !["Liter", "litre"].includes(product.price.basic.unit)
        ? i18n.t("price_incl_vat")
        : product.configuration.subscription
        ? i18n.t("price_per_litre_subscription", {
              basic_price: formatPrice(product.price.basic.taxed, product.price.currency.name, language),
              amount: product.configuration.subscription.max_quantity,
              price: formatPrice(
                  (product.price.basic.taxed * (product.configuration.subscription.max_quantity - 1)) /
                      product.configuration.subscription.max_quantity,
                  product.price.currency.name,
                  language
              ),
          })
        : i18n.t("price_per_litre", {
              price: formatPrice(product.price.basic.taxed, product.price.currency.name, language),
          })
}

export { smallprint }
